module.exports = __webpack_public_path__ + "static/the-angel-guest-133f17eb76cef9d148ab2028e6a979e2.jpg";